import BlankView from '@/components/BlankView.vue'
const standingBookManagement = [ 
      {
        path: 'standingBookManagement',
        name: '台账管理',
        component: BlankView,
        children:[
           //司机运输台账管理
          {
            path: 'transportationAccountManagement',
            name: 'transportationAccountManagement',
            component: () => import('@/views/standingBookManagement/transportationAccountManagement.vue'),
          },
          //鑫诚砂石自购台账管理
          {
            path: 'selfpurchaseAccountManagement',
            name: 'selfpurchaseAccountManagement',
            component: () => import('@/views/standingBookManagement/selfpurchaseAccountManagement.vue'),
          },
          //鑫诚砂石销售台账管理
          {
            path: 'salesAccountManagement',
            name: 'salesAccountManagement',
            component: () => import('@/views/standingBookManagement/salesAccountManagement.vue'),
          },
          //柴油入库管理
          {
            path: 'oilInManagement',
            name: 'oilInManagement',
            component: () => import('@/views/standingBookManagement/oilInManagement.vue'),
          },
          //柴油库存管理
          {
            path: 'oilStorageManagement',
            name: 'oilStorageManagement',
            component: () => import('@/views/standingBookManagement/oilStorageManagement.vue'),
          },
        ]
      }
    
];


export default standingBookManagement;